import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { loginAs } from '../../actions';
import View from './view';
import { ReduxState } from '../../types/redux_types';
import { Action } from '../../types/global_reducer';
import { LoginPayload } from '../../types/common';

const mapStateToProps = (state: ReduxState) => ({
  isAuthenticated: state.global.isAuthenticated,
  apps: state.global.userDetails.apps,
  accountId: state.global.selectedAccountId,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<ReduxState, void, Action>) => ({
  actions: {
    loginAs: ({
      name,
      accountList,
      token,
      email,
      cob_unverified,
      isSDProTileEnabled,
    }: LoginPayload) => {
      dispatch(loginAs({ name, accountList, token, email, cob_unverified, isSDProTileEnabled }));
    },
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
